module.exports = __webpack_public_path__ + "static/media/newGIF.e044ff2f.gif";